import React, { forwardRef } from "react";
import { getThermalReceiptStyles } from "./thermalReceiptStyles";
import { ThermalShopHeader, DashedRule, getShopHeaderProps } from "./ThermalShopHeader";
import { formatDateTime } from "../../utils/dateTime";

const formatRs = (n) =>
  `Rs ${Number(n || 0).toLocaleString("en-PK", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const paymentTypeLabel = (type) => {
  if (type === 1 || type === "Cash") return "Cash";
  if (type === 2 || type === "Bank") return "Bank";
  return String(type || "—");
};

const ThermalCustomerPayment = forwardRef(({ data }, ref) => {
  if (!data) return null;

  const {
    date,
    invoice_no,
    customer_name,
    payment_type,
    bank_name,
    bank_number,
    amount,
    desc,
  } = data;

  const formattedDate = formatDateTime(date || Math.floor(Date.now() / 1000));

  const shop = getShopHeaderProps(data);
  const isBank = Number(payment_type) === 2 || payment_type === "Bank";

  const headerRight = (
    <div className="tr-header-right">
      <div className="tr-header-right-line">
        <span>Bill #:</span>{" "}
        {invoice_no != null && String(invoice_no).trim() !== ""
          ? String(invoice_no).trim()
          : "—"}
      </div>
    </div>
  );

  return (
    <div ref={ref} className="thermal-receipt">
      <style>{getThermalReceiptStyles()}</style>

      <ThermalShopHeader
        formattedDate={formattedDate}
        headerRight={headerRight}
        shop={shop}
      />

      <div className="tr-section-title">▶ PAYMENT RECEIPT</div>

      <div className="tr-customer-row">
        <div className="tr-customer-label">
          <span>👤</span>
          <span>Customer:</span>
        </div>
        <div className="tr-customer-value">{customer_name || "—"}</div>
      </div>

      <div className="tr-solid-thick" />

      <div className="tr-pay-row">
        <span>Payment Type:</span>
        <span className="tr-pay-value">{paymentTypeLabel(payment_type)}</span>
      </div>
      {isBank && (
        <>
          <div className="tr-pay-row">
            <span>Bank:</span>
            <span className="tr-pay-value">{bank_name || "—"}</span>
          </div>
          {bank_number != null && String(bank_number).trim() !== "" && (
            <div className="tr-pay-row">
              <span>Account #:</span>
              <span className="tr-pay-value">{String(bank_number)}</span>
            </div>
          )}
        </>
      )}

      <div className="tr-amount-highlight">{formatRs(amount)}</div>

      {desc && (
        <div className="tr-desc-block">
          <span>Description:</span> {desc}
        </div>
      )}

      <DashedRule />
      <div className="tr-thanks">★ Thank You For Your Business ★</div>
    </div>
  );
});

ThermalCustomerPayment.displayName = "ThermalCustomerPayment";

export default ThermalCustomerPayment;
